import agriculture from "../images/agriculture.png"
import spices from "../images/spices.png"
import dalmakhani from "../images/dal-makhani.png"
import fresh from "../images/fresh.png"
import constructionsite from "../images/constructionsite.png"
export const productCategories = [
  {
    image:agriculture,
    title: "Agricultural & Food Products",
    description:
      "We export premium-quality agricultural goods sourced directly from trusted farms across India. With strict quality checks and hygienic packaging, we ensure freshness and purity in every shipment."
  },
  {
    image:spices,
    title: "Spices & Seasonings",
    description:
      "India is known for its rich spice heritage, and we bring that authentic taste to the world. From whole spices to blended seasonings, all products are carefully processed and packaged to retain maximum aroma and flavor."
  },
  {
    image:dalmakhani,
    title: "Pulses & Grains",
    description:
      "Our pulses and grains are handpicked, cleaned, and graded to meet international export standards. We offer bulk and container shipments with guaranteed consistency and quality."
  },
  {
    image:fresh,
    title: "Fresh & Processed Food Items",
    description:
      "We supply a wide range of fresh and packaged food products that meet global hygiene and safety regulations—ensuring longer shelf life, premium quality, and excellent taste."
  },
  {
    image:constructionsite,
    title: "Industrial & General Trade Products",
    description:
      "We also export various non-food items for industrial and commercial use, ensuring durability, reliability, and competitive pricing for global buyers."
  }
];
